import { FC } from 'react';
import { Code, Icon, Text, VStack } from '@wegroup/design-system';
import { ErrorResponse } from '../../../../../types/API';
import { useTranslation } from 'react-i18next';

interface Props {
  error?: Error;
}

const FlowProductsCalculateError: FC<Props> = ({ error }) => {
  const { t } = useTranslation();

  const errorObj = error?.message
    ? (JSON.parse(error?.message) as ErrorResponse)
    : undefined;

  return (
    <VStack
      justify="center"
      h="full"
      spacing="2"
      maxW="2xl"
      textAlign="center"
      px="3"
    >
      <Icon
        name="GeneralStatusWarningTriangle"
        color="danger.main"
        boxSize="10"
      />
      <Text textStyle="h5Headline">{t('ErrorPopup.title')}</Text>
      <Text fontSize="md" color="gray.500">
        {errorObj?.msg}
      </Text>
      {errorObj?.detail && (
        <Code
          p="3"
          overflow="auto"
          maxW="4xl"
          bg="white"
          border="1px"
          borderColor="gray.50"
          textAlign="left"
          whiteSpace="pre"
        >
          {(JSON.stringify(errorObj?.detail, null, 2) || '').replace(
            /\\\\n/g,
            '\n',
          )}
        </Code>
      )}
    </VStack>
  );
};

export default FlowProductsCalculateError;
